module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/2-923b2f73a71c4ec384999e2f11baa5b6.jpg";